import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import AsyncOpenHelpPanelLinkThroughEventListener from '@atlassian/jira-help-panel-button/src/async';
import AsyncLegacyTeamProfileCard from '@atlassian/jira-profilecard-next/src/ui/team-profilecard-legacy/async';
import type { RouteContext } from '@atlassian/jira-router';
import { LegacyPage } from '@atlassian/jira-router-routes-common';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller';

type Props = RouteContext;

export const LegacyPageWithTeamProfileCardView = (props: Props) => (
	<>
		<LegacyPage {...props} />

		<AsyncOpenHelpPanelLinkThroughEventListener />

		{ff('ptc.enabled.legacy-profile.card') ? (
			<AsyncLegacyTeamProfileCard TenantContextSubscriber={TenantContextSubscriber} />
		) : null}
	</>
);
